
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import axios from "axios";
import moment from 'moment';
import 'moment/min/locales'

import authHeader from "../services/auth-header";
import { useTranslation } from "react-i18next";

const api = require("../api/names.js");



function DetectorsSleepAndAck(props) {

  const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [state, setState] = React.useState('600');

    const params = useParams();
    useEffect(() => {
      loadCurrentDataFromApi(params.addressMin, params.addressMax);

      const interval = setInterval(() => {
        loadCurrentDataFromApi(params.addressMin, params.addressMax);
      }, 5000);

      return () => clearInterval(interval);

    },[params.addressMax, params.addressMin])

  function setAckFlagForAll(items,flag) {
    items.map(item => (

      changeAck(item.address,flag)
    )
  )
  }

  function setSleepForAll(items) {
    items.map(item => (

      changeSleep(item.address,state)
    )
  )
  }

    function changeAck(adres, autonoack) {
        var url = api.baseUrl + '/detectorsEUIs/'+adres;

        if(autonoack === 0)
        {
          autonoack = 1;
        }
        else {
          autonoack = 0;
        }
        const jsonData = {
            "autonoack": autonoack
        }
        axios.put(url, jsonData, { headers: authHeader() });

    }

    function changeSleep(adres, sleep) {
        var url = api.baseUrl + '/detectorsEUIs/'+adres;


        const jsonData = {
            "autosleep": sleep
        }
        axios.put(url, jsonData, { headers: authHeader() });

    }

    function loadCurrentDataFromApi(addressMin, addressMax) {

        var url = api.baseUrl+'/detectorsEUIs/WithVersionMinMaxAddress/';
        url += addressMin;
        url += '/';
        url += addressMax;



      console.log(url);
      fetch(url, {
   method: 'get',
   headers: authHeader()
 })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          setIsLoaded(true);
          setItems(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
    }

    if (error) {
      return <div>{t('detectord.error')}{error.message}</div>;
     } else if (!isLoaded) {
      return <div>{t('detectord.loading')}</div>;
     } else {
       return (

<div>
      <input
        value={state}
        onChange={(event) => {
          setState(event.target.value);
        }}
      />

      <p>
        <strong>Sleep time: </strong>
        {state} hour(s)
      </p>

  <TableContainer component={Paper}>
   <Table sx={{ minWidth: 650 }} aria-label="simple table">
     <TableHead>
        <TableRow>

                   <TableCell >ADRES</TableCell>
                   <TableCell >SLEEP <Button
          onClick={() => setSleepForAll(items)}
        >
          SET SLEEP FOR ALL
        </Button></TableCell>
                   <TableCell >ACK FLAG <Button
          onClick={() => setAckFlagForAll(items,0)}
        >
          SET ACK FLAG FOR ALL
        </Button> <Button
onClick={() => setAckFlagForAll(items,1)}
>
UNSET ACK FLAG FOR ALL
</Button></TableCell>
                   <TableCell >CURRENT ACK</TableCell>
                   <TableCell >Last frame time</TableCell>
       </TableRow>
     </TableHead>
     <TableBody>
       {items.map(item => (
         <TableRow
           key={item.id}
           sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
         >

           <TableCell >{item.address}</TableCell>
           <TableCell >{item.autosleep}h <Button
  onClick={() => changeSleep(item.address, state)}
>
  Set sleep
</Button></TableCell>
           <TableCell >{item.autonoack} <Button
  onClick={() => changeAck(item.address, item.autonoack)}
>
  Toggle ACK
</Button></TableCell>


           <TableCell >{item.detectorsVersion.flags}</TableCell>
           <TableCell >{moment(item.detectorsVersion.updatedAt).format()}</TableCell>
           <TableCell >{moment(item.detectorsVersion.updatedAt).fromNow()}</TableCell>

         </TableRow>
       ))}
     </TableBody>
   </Table>
  </TableContainer>
  </div>





       );
     }
   }

export default DetectorsSleepAndAck;
